import styled from "styled-components";
import { MOBILE_BREAKPOINT_NUMBER } from "../../styles/breakpoints";
import { MainButton, MainButtonProps } from "./MainButton";
import { ProgressButton, ProgressButtonProps } from "./ProgressButton";
import { TextButton, TextButtonProps } from "./TextButton";

type Props = {
  textButton?: TextButtonProps;
  progressButton?: ProgressButtonProps & {
    numberOfSteps?: number;
    currentStep?: number;
  };
  spaceBetween?: boolean;
  mainButton?: MainButtonProps;
  className?: string;
  column?: boolean;
};

export const ButtonGroup = ({
  textButton,
  progressButton,
  mainButton,
  spaceBetween,
  className,
  column,
}: Props) => {
  return (
    <Container
      className={className}
      $column={column}
      $spaceBetween={spaceBetween}
    >
      {textButton && <TextButton className="text-button" {...textButton} />}
      {progressButton && (
        <ProgressButton className="progress-button" {...progressButton} />
      )}
      {mainButton && <MainButton className="main-button" {...mainButton} />}
    </Container>
  );
};

const Container = styled.div<{ $column?: boolean; $spaceBetween?: boolean }>`
  display: flex;
  flex-direction: ${({ $column }) => ($column ? "column-reverse" : "row")};
  gap: 20px;
  width: 100%;
  justify-content: ${({ $spaceBetween }) =>
    $spaceBetween ? "space-between" : "flex-end"};
  align-items: ${({ $column }) => ($column ? "center" : "flex-end")};
  padding: 10px 0 10px 0;
  @media (max-width: ${MOBILE_BREAKPOINT_NUMBER - 40}px) {
    flex-direction: column-reverse;
    gap: 10px;
    align-items: center;
  }
`;
